import { TAddress, provinceFull } from '../types/entities/users';
import { cityFull } from '../types/entities/city';

export default function (address: TAddress) {
  if (!address) return '';

  const addressParts = [
    address.address,
    address.district,
    cityFull[address.cityRegency],
    provinceFull[address.province]
  ];
  const postalCodeAndCountry = address.postalCode
    ? address.country
      ? `${address.postalCode}, ${address.country}`
      : address.postalCode
    : '';
  if (postalCodeAndCountry) {
    addressParts.push(postalCodeAndCountry);
  }

  return addressParts.filter(Boolean).join(', ');
}
